import React from "react";
import Navbar from "./Navbar";
import CryptoTicker from "./CryptoTicker";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation();
  const showTicker = location.pathname === "/" || location.pathname === "/dashboard";
  return (
    <div className="relative min-h-screen">
      <div className="aurum-bg" />
      <div className="aurum-grid" />
      <div className="aurum-noise" />
      <Navbar />
      {showTicker && <CryptoTicker />}
      <main className="max-w-[1400px] mx-auto px-6 lg:px-8 py-10">{children}</main>
      <footer className="max-w-[1400px] mx-auto px-6 lg:px-8 py-12 text-xs text-neutral-500 flex justify-between border-t border-white/5 mt-12">
        <span className="font-display">Wealth Builders · Wealth Tracker for World Markets</span>
        <span>© 2026 — Powered by Alpha Vantage · CoinGecko · NewsAPI · OpenSea · Claude</span>
      </footer>
    </div>
  );
};

export default Layout;
